module.exports = __webpack_public_path__ + "static/media/insulation_lcs_60y_n.ffb441b2.csv";